import React from "react";
import moment from "moment";

class Activity extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { message } = this.props;
        
        return (
            <div class="conversation-message-activity">
                <div class="activity-content">
                    {message.user ?
                        <span>{message.event }</span>
                    : 
                        <div class="newConvo">{message.event==='New Message'?'New':message.event}</div>
                    }
                    
                </div>
            </div>
        );
    }
}

export default Activity;